'use strict';

angular.module('TurneroApp').component('coAgendaPaso5', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        '$scope',
        '$rootScope',
        'agendaService',
        'TurneroAppConstant',
        'utilsService',
        //prueba 2
        function ($scope, $rootScope, agendaService, TurneroAppConstant, utilsService) {
            var ctrl = this;
            ctrl.Estados = TurneroAppConstant.Estados.Agenda;
            ctrl.limpiarMemoria = function () {
                ctrl.Agenda = {
                    Id_Agenda: null,
                    Id_Usuario: '',
                    Permite_Datos_Adicionales: '',
                    Permite_Observaciones: '',
                    Tiempo_Tolera_Anuncio: null,
                    Mostrar_Estado_Agendado: '',
                    Permite_Anunciar_Sin_Tasas: '',
                    Id_Estado: 0,
                    Es_Agenda_Online: '',
                    Pedir_Nro_Sticker: '',
                    Notificaciones: null,
                    Tipo_Derivaciones: null,
                    Tiene_Tasa_Retributuva: '',
                    Notificaciones_Alta: '',
                    Derivaciones_Alta: '',
                    Llamar_Por_Numero_Ticket: '',
                    Solo_Cidi_Nivel_2: '',
                    Atencion_Virtual: '',
                    Solicitar_Patente_Dominio: 'N'
                }
                ctrl.errores = { Notificaciones: [] }
            };
            ctrl.textoNotificacion = {index: -1};

            $scope.$on('inicioAgendaPaso5_load', function (event, obj) {
                ctrl.limpiarMemoria();
                ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
                ctrl.agendaNueva = obj.isNew;
                if (ctrl.Agenda.Id_Agenda != null) {
                    agendaService.Get_Paso5({ 'Id_Agenda': ctrl.Agenda.Id_Agenda, 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
                        ctrl.Agenda = resultado.Data;
                        ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
                        ctrl.Agenda.Id_Estado = obj.Id_Estado;
                        ctrl.Agenda.usaMargenTiempoAnuncio = ctrl.Agenda.Tiempo_Tolera_Anuncio > 0 ? true : false;
                        ctrl.Agenda.Permitir_Cancelar_Turno = ctrl.Agenda.Permitir_Cancelar_Turno ? ctrl.Agenda.Permitir_Cancelar_Turno : 'S';
                        ctrl.Agenda.Permite_Atencion = ctrl.Agenda.Permite_Atencion ? ctrl.Agenda.Permite_Atencion : 'S';
                        ctrl.Agenda.Mostrar_Tasas = ctrl.Agenda.Mostrar_Tasas ? ctrl.Agenda.Mostrar_Tasas : 'N';
                        ctrl.Agenda.Notificaciones_Alta = '';
                        ctrl.Agenda.Derivaciones_Alta = '';
                        ctrl.Agenda.No_Muestra_Recepcion = resultado.Data.No_Muestra_Recepcion === "S" ? "S" : "N"; //Por defecto N
                        ctrl.Agenda.Atencion_Virtual = resultado.Data.Atencion_Virtual === "S" ? "S" : "N"; //Por defecto N
                        ctrl.validarNotificaciones();
                    }).catch(function (error) {
                        utilsService.errores(error);
                    })
                }
            });

            ctrl.cambiarVista = function (funcion) {
                funcion(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
            };

            ctrl.switchTab = function (paso, funcion) {
                var pasoActual = 1;

                if (ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente && pasoActual > paso) {
                    ctrl.cambiarVista(funcion);
                } else if (ctrl.Agenda.Id_Estado != TurneroAppConstant.Estados.Agenda.Pendiente) {
                    ctrl.cambiarVista(funcion);
                }
            };

            ctrl.cancelar = function (mostrarMensaje = false) {               
                if (mostrarMensaje) {
                    ctrl.ctrlPadre.mostrarMensajeFinal();
                } else {
                    ctrl.limpiarMemoria();
                    ctrl.ctrlPadre.consultaAgendas(true);
                }                
            };

            ctrl.guardarPaso5 = function (paso_siguiente) {
                if (ctrl.ctrlPadre.readOnly) {
                    ctrl.ctrlPadre.consultaAgendas(true);
                } else {
                    utilsService.swalTitle('Procesando datos.', 'info');
                    if (ctrl.validarForm()) {
                        if (ctrl.Agenda.Id_Agenda != null) {
                            var Estado = ctrl.Agenda.Id_Estado;
                            agendaService.Put_Agenda_Paso5(({ 'id': ctrl.Agenda.Id_Agenda }, ctrl.Agenda)).$promise.then(function (result) {
                                swal.close();

                                if (result.Data && result.Data.length > 0) {
                                    swal({
                                        title: 'Tramites repetidos',
                                        html: "Uno de los trámites ya existe online para otra agenda. Presione aceptar si desea exportar el listado a excel.",
                                        type: 'info',
                                        confirmButtonColor: '#004b81',
                                        confirmButtonText: 'Aceptar',
                                        showCancelButton: true,
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        cancelButtonColor: '#971b2f',
                                        cancelButtonText: 'Cancelar'
                                    }).then(function (respuesta) {
                                        if (respuesta === true) {
                                            exportarExcel(result.Data);
                                        }
                                    })
                                } else {
                                    ctrl.cancelar(true);
                                }
                            }).catch(function (error) {
                                swal.close();
                                utilsService.errores(error);
                            })
                        }
                    }
                }
            };

            ctrl.validarNotificaciones = function () {
                ctrl.errores.Notificaciones = [];
                for (var index = 0; index < ctrl.Agenda.Notificaciones.length; index++) {
                    var SMS = "";
                    var Mail = "";
                    if ((ctrl.Agenda.Notificaciones[index].Notifica_SMS == 'S' && ctrl.Agenda.Notificaciones[index].Texto_SMS) || ctrl.Agenda.Notificaciones[index].Editable == 'N' || ctrl.Agenda.Notificaciones[index].Notifica_SMS == 'N') {
                        SMS = false;
                    } else {
                        SMS = true;
                    };
                    if ((ctrl.Agenda.Notificaciones[index].Notifica_Mail == 'S' && ctrl.Agenda.Notificaciones[index].Texto_Mail) || ctrl.Agenda.Notificaciones[index].Notifica_Mail == 'N' || ctrl.Agenda.Notificaciones[index].Editable == 'N') {
                        Mail = false;
                    } else {
                        Mail = true;
                    };
                    ctrl.errores.Notificaciones[index] = {
                        SMS: SMS,
                        Mail: Mail
                    }
                }
            };

            ctrl.validarForm = function () {

                try {
                    if (ctrl.Agenda.usaMargenTiempoAnuncio && !(ctrl.Agenda.Tiempo_Tolera_Anuncio % 5 == 0)) {
                        sweetAlert(
                            "Datos Requeridos",
                            "El tiempo para restringir la hora en la que el interesado puede anunciarse debe ser múltiplo de 5",
                            "warning");
                        return false;
                    }
                    for (var i = 0; i < ctrl.errores.Notificaciones.length; i++) {
                        if (ctrl.errores.Notificaciones[i].SMS || ctrl.errores.Notificaciones[i].Mail) {
                            sweetAlert("Datos Requeridos", 'Se ha encontrado un error en la notificación : "' + ctrl.Agenda.Notificaciones[i].N_Notificacion + '". La opcion de enviar ' + (ctrl.errores.Notificaciones[i].SMS ? 'SMS ' : 'Mail') + ', esta seleccionada pero no tiene ningún texto para enviar.', "warning");
                            return false
                        }
                    }

                    ctrl.Agenda.Llamar_Por_Numero_Ticket = ctrl.Agenda.Llamar_Por_Numero_Ticket ? ctrl.Agenda.Llamar_Por_Numero_Ticket : 'N';
                    ctrl.Agenda.Solo_Cidi_Nivel_2 = ctrl.Agenda.Solo_Cidi_Nivel_2 ? ctrl.Agenda.Solo_Cidi_Nivel_2 : 'N';
                    ctrl.Agenda.Es_Agenda_Online = ctrl.Agenda.Es_Agenda_Online ? ctrl.Agenda.Es_Agenda_Online : 'N';
                    ctrl.Agenda.Mostrar_Estado_Agendado = ctrl.Agenda.Mostrar_Estado_Agendado ? ctrl.Agenda.Mostrar_Estado_Agendado : 'N';
                    ctrl.Agenda.Visualiza_Documentacion = ctrl.Agenda.Visualiza_Documentacion ? ctrl.Agenda.Visualiza_Documentacion : 'N';
                    ctrl.Agenda.Pedir_Nro_Sticker = ctrl.Agenda.Pedir_Nro_Sticker ? ctrl.Agenda.Pedir_Nro_Sticker : 'N';
                    ctrl.Agenda.Permite_Anunciar_Sin_Tasas = ctrl.Agenda.Permite_Anunciar_Sin_Tasas ? ctrl.Agenda.Permite_Anunciar_Sin_Tasas : 'N';
                    ctrl.Agenda.Permite_Datos_Adicionales = ctrl.Agenda.Permite_Datos_Adicionales ? ctrl.Agenda.Permite_Datos_Adicionales : 'N';
                    ctrl.Agenda.Permite_Observaciones = ctrl.Agenda.Permite_Observaciones ? ctrl.Agenda.Permite_Observaciones : 'N';
                    ctrl.Agenda.Permite_Seleccion_Llamar = ctrl.Agenda.Permite_Seleccion_Llamar ? ctrl.Agenda.Permite_Seleccion_Llamar : 'N';
                    ctrl.Agenda.Permite_Sobreturno = ctrl.Agenda.Permite_Sobreturno ? ctrl.Agenda.Permite_Sobreturno : 'N';
                    ctrl.Agenda.Tiempo_Tolera_Anuncio = ctrl.Agenda.usaMargenTiempoAnuncio ? (ctrl.Agenda.Tiempo_Tolera_Anuncio > 0 ? ctrl.Agenda.Tiempo_Tolera_Anuncio : null) : null;
                    ctrl.Agenda.Tiene_Tasa_Retributuva = ctrl.Agenda.Tiene_Tasa_Retributuva ? ctrl.Agenda.Tiene_Tasa_Retributuva : 'N';
                    ctrl.Agenda.Mostrar_Tasas = ctrl.Agenda.Mostrar_Tasas ? ctrl.Agenda.Mostrar_Tasas : 'N';
                    ctrl.Agenda.Atencion_Virtual = ctrl.Agenda.Atencion_Virtual ? ctrl.Agenda.Atencion_Virtual : 'N';
                    ctrl.Agenda.Solicitar_Patente_Dominio = (ctrl.Agenda.Solicitar_Patente_Dominio === 'S') ? 'S' : 'N';

                    //Notificaciones
                    ctrl.Agenda.Notificaciones_Alta = ""; // Limpio la variable, porque si salta error y le doy guardar nuevamente me concatena los datos y me los repite N veces.
                    for (var i = 0; i < ctrl.Agenda.Notificaciones.length; i++) {
                        var item = ctrl.Agenda.Notificaciones[i].Id_Notificacion + '@@' +
                            (ctrl.Agenda.Notificaciones[i].Notifica_Mail == '' ? 'N' : ctrl.Agenda.Notificaciones[i].Notifica_Mail) + '@@' +
                            (ctrl.Agenda.Notificaciones[i].Notifica_SMS == '' ? 'N' : ctrl.Agenda.Notificaciones[i].Notifica_SMS) + '@@' +
                            (ctrl.Agenda.Notificaciones[i].Texto_Mail == '' || ctrl.Agenda.Notificaciones[i].Editable == 'N' ? 'null' : ctrl.Agenda.Notificaciones[i].Texto_Mail) + '@@' +
                            (ctrl.Agenda.Notificaciones[i].Texto_SMS == '' || ctrl.Agenda.Notificaciones[i].Editable == 'N' ? 'null' : ctrl.Agenda.Notificaciones[i].Texto_SMS)
                        ctrl.Agenda.Notificaciones_Alta = ctrl.Agenda.Notificaciones_Alta ? (ctrl.Agenda.Notificaciones_Alta + '|' + item) : item;

                    }

                    //Derivaciones
                    ctrl.Agenda.Derivaciones_Alta = ""; // Limpio la variable, porque si salta error y le doy guardar nuevamente me concatena los datos y me los repite N veces.
                    for (var i = 0; i < ctrl.Agenda.Tipo_Derivaciones.length; i++) {
                        var item = ctrl.Agenda.Tipo_Derivaciones[i].Id_Tipo_Derivacion + ',' +
                            (ctrl.Agenda.Tipo_Derivaciones[i].Notifica == '' ? 'N' : ctrl.Agenda.Tipo_Derivaciones[i].Notifica);
                        ctrl.Agenda.Derivaciones_Alta = ctrl.Agenda.Derivaciones_Alta ? (ctrl.Agenda.Derivaciones_Alta + '|' + item) : item;
                    }
                    if (ctrl.Agenda.usaMargenTiempoAnuncio) {
                        if (!ctrl.Agenda.Tiempo_Tolera_Anuncio) {
                            sweetAlert("Datos Requeridos", "Se ha seleccionado 'Restringir la hora en la que el interesado puede anunciarse', por lo que debe ingresarse cuanto tiempo antes puede anunciarse el ciudadano, por favor complételo.", "warning");
                            return false;
                        }
                    }

                    return true;
                } catch (e) {
                    return false;
                }
            };

            function exportarExcel(data) {
                var arrayObject = data;
                ctrl.arrayExport = [];
                ctrl.arrayExport[1] = ['Número y Nombre de Tramite', 'Número y Nombre de Agenda'];
                for (var i = 0; i < arrayObject.length; i++) {
                    var index = ctrl.arrayExport.length;
                    ctrl.arrayExport[ctrl.arrayExport.length] = [arrayObject[i].Tramite, arrayObject[i].Agendas[0]];
                    for (var j = 1; j < arrayObject[i].Agendas.length; j++) {
                        ctrl.arrayExport[ctrl.arrayExport.length] = [' ', arrayObject[i].Agendas[j]];
                    }

                }
                swal.close();
                ctrl.Excel.down([{
                    name: 'Tramites_Repetidos',
                    data: ctrl.arrayExport
                }]);

            }

            ctrl.Excel = {
                down: function () {
                },
            }
            document.getElementById("am-listado-notificaciones").style.display = "none"
        }
    ],
    template: require('./agenda_Paso5.html')
    
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_Paso5Component.js